'use strict';

var _classCallCheck = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
var _get = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");
var _getPrototypeOf = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");
var _inherits = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");
var _createSuper = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");
var Container = require('./container');
var AtRule = /*#__PURE__*/function (_Container) {
  _inherits(AtRule, _Container);
  var _super = _createSuper(AtRule);
  function AtRule(defaults) {
    var _this;
    _classCallCheck(this, AtRule);
    _this = _super.call(this, defaults);
    _this.type = 'atrule';
    return _this;
  }
  _createClass(AtRule, [{
    key: "append",
    value: function append() {
      var _get2;
      if (!this.proxyOf.nodes) this.nodes = [];
      for (var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++) {
        children[_key] = arguments[_key];
      }
      return (_get2 = _get(_getPrototypeOf(AtRule.prototype), "append", this)).call.apply(_get2, [this].concat(children));
    }
  }, {
    key: "prepend",
    value: function prepend() {
      var _get3;
      if (!this.proxyOf.nodes) this.nodes = [];
      for (var _len2 = arguments.length, children = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        children[_key2] = arguments[_key2];
      }
      return (_get3 = _get(_getPrototypeOf(AtRule.prototype), "prepend", this)).call.apply(_get3, [this].concat(children));
    }
  }]);
  return AtRule;
}(Container);
module.exports = AtRule;
AtRule.default = AtRule;
Container.registerAtRule(AtRule);